import type { WebsiteContent } from './types'

export const navigation: WebsiteContent['navigation'] = {
  secondaryCta: 'CONTACT US',
}
